import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import LowerHeader from '../../components/Header/LowerHeader/LowerHeader';
import '../../components/Dealers/Dealers.css';
import PaymentEdit from './PaymentEdit';
import capitaliseSentence from '../../utils/CapitaliseSentence';
import Toolbar from '../../components/Header/Toolbar/Toolbar';

class PaymentEditContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      payment: props.location.state ? props.location.state.payment : null,
      authToken: localStorage.getItem('authToken'),
    };
    this.BackToPayments = this.BackToPayments.bind(this);
  }

  BackToPayments() {
    this.props.history.push({
      pathname: '/dashboard',
    });
  }

  componentDidMount() {
    const { authToken } = this.state;
    if (!authToken) {
      this.props.history.push({
        pathname: '/sessionexpired',
        state: {
          error: 'Unauthorised or Session Expired',
          error_description: 'Please try to login again',
        },
      });
    } else {
      const obj = document.getElementById('navLoginLogout');
      obj.innerText = 'Logout';
    }
  }

  render() {
    return (
      <React.Fragment>
        <div className="container-header">
          <Toolbar />
        </div>
        <div className="container-fluid text-center">
          <div className="dealerUpperHeader">
            <button className="btn btn-primary" onClick={this.BackToPayments}>
              <strong>Back to Payments</strong>
            </button>
          </div>

          <LowerHeader pageTitle="Edit Payments" />

          {/* Dealer */}
          <div className="dealerAddressWrapper">
          <span className="dealerAddressName">
            <strong>UUID : </strong>
              {this.state.payment.id? this.state.payment.id : 'No Booking UUID'}
              <br/>
            </span>
            <span className="dealerAddressName">
            <strong>Dealer Details : </strong>
              {this.state.payment.dealerName ? this.state.payment.dealerName.toUpperCase() : 'No Dealer Name'}
              <br/>
            </span>
            <span className="dealerAddressName">
            <strong>Location Details : </strong>
              {this.state.payment.locationName ? this.state.payment.locationName : 'No Location Details'}
              <br/>
            </span>
            <span className="dealerAddressName">
            <strong>Error History : </strong>
            {this.state.payment.errorHistory ? this.state.payment.errorHistory.toUpperCase() : 'No Error History'}
              <br />
            </span>
            <span className="dealerAddressName">
            <strong>Booking Id : </strong>
            {this.state.payment.bookingId ? this.state.payment.bookingId.toUpperCase() : 'No Booking ID'}
            </span>
          </div>

          {/* Toggle Table from props.rowdata features */}
          <br />
          <PaymentEdit payment={this.state.payment} authToken={this.state.authToken} />
        </div>
      </React.Fragment>
    );
  }
}

export default withRouter(PaymentEditContainer);



// WEBPACK FOOTER //
// ./src/containers/PaymentDashboard/PaymentEditContainer.js